import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Paper, Typography } from '@material-ui/core'
import IntlMessages from '@crema/utility/IntlMessages'
import RedButton from 'components/Button/RedButton'
import NormalTable from 'components/Table/NormalTable'
import StaffTimeOffTable from 'components/Temple/StaffTimeOffTable'
import React, { useEffect, useState } from 'react'
import { RouteComponentProps } from 'react-router'
import { useAppDispatch, useAppSelector } from 'store/hooks'
import {
    selectCurrentTempleStaffTimeOff,
    selectStaffTimeOffStatus,
    staffTimeOffDeleteThunk,
    staffTimeOffListThunk,
} from 'store/reducers/temple/staffTimeOffSlice'
import { StaffTimeOffResponseType } from 'types/api/temple'
import usePermissionCheck from 'hooks/usePermissionCheck'
import { PERMISSIONS, RESTRICTED_PATHS } from 'utils/permissions'

const ListStaffTimeOff: React.FC<RouteComponentProps> = ({ history, location }) => {
    const dispatch = useAppDispatch()
    const items = useAppSelector(selectCurrentTempleStaffTimeOff)
    const api = useAppSelector(selectStaffTimeOffStatus)
    const permissions = usePermissionCheck(RESTRICTED_PATHS.STAFF_TIME_OFF)
    const [deleteItem, setDeleteItem] = useState<StaffTimeOffResponseType | null>(null)
    const [deletingIds, setDeletingIds] = useState<(string | number)[]>([])

    useEffect(() => {
        dispatch(staffTimeOffListThunk({}))
    }, [dispatch])

    const handleDelete = (canDelete?: boolean) => {
        if (canDelete && deleteItem) {
            setDeletingIds(prev => [...prev, deleteItem.id])
            dispatch(staffTimeOffDeleteThunk({ id: deleteItem.id }))
                .finally(() => {
                    setDeletingIds(prev => prev.filter(id => id !== deleteItem.id))
                    setDeleteItem(null)
                })
        } else {
            setDeleteItem(null)
        }
    }

    return (
        <Paper>
            <NormalTable
                api={api}
                toolbar={
                    <Box display='flex' justifyContent='space-between' p={5}>
                        <Typography variant='h6'>Staff Time Off</Typography>
                        {permissions.includes(PERMISSIONS.ADD) && (
                            <Button
                                color='primary'
                                variant='contained'
                                onClick={() => history.push(`${location.pathname}/add`)}
                            >
                                Apply Time Off
                            </Button>
                        )}
                    </Box>
                }
            >
                <StaffTimeOffTable
                    items={items}
                    editHandler={permissions.includes(PERMISSIONS.CHANGE) ? id => history.push(`${location.pathname}/edit/${id}`) : undefined}
                    deleteHandler={permissions.includes(PERMISSIONS.DELETE) ? id => {
                        const item = items.find(row => row.id === id)
                        if (item) setDeleteItem(item)
                    } : undefined}
                    deletingIds={deletingIds}
                />
            </NormalTable>
            <Dialog open={Boolean(deleteItem)}>
                <DialogTitle>{`Delete time off for ${deleteItem?.staffName}?`}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        This removes the selected leave/time-off record and its generated occurrences.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' color='primary' onClick={() => handleDelete(false)}>
                        <IntlMessages id='common.cancel' />
                    </Button>
                    <RedButton variant='outlined' onClick={() => handleDelete(true)} autoFocus>
                        <IntlMessages id='common.delete' />
                    </RedButton>
                </DialogActions>
            </Dialog>
        </Paper>
    )
}

export default ListStaffTimeOff
